// extracted by mini-css-extract-plugin
module.exports = {"section":"I_section__B_giH"};